import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

export default function Member_daily_report() {
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [listProjectArray, setListProjectArray] = useState([]);
    const [listProjectMembersArray, setListProjectMembersArray] = useState([]);
    const [dailySummary, setDailySummary] = useState('');
    const [superAdminId, setSuperAdminId] = useState(null);
    const [reportsent, setReportsent] = useState('no');
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const today = new Date();
        setSelectedDate(today);
        fetchActivity(today);
        const userid = localStorage.getItem('member_id');
        var obj = {
            userid: userid
        }
        $.ajax({
            type: 'POST',
            url: 'getMembersProjects.php',
            data: obj,
            cache: false,
            success: function (result) {

                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                        setDropDown(parsedResult);
                        loadMemberListForProject();
                    } else {
                        showAlert('You have No active projects.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load your record.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });

    }, [])


    useEffect(() => {
        const comid = localStorage.getItem('mem_company_id');

        $.ajax({
            type: "POST",
            url: "getSuperAdminByCompany.php",
            data: { comid },
            success: function (res) {
                if (res.status === "success") {
                    setSuperAdminId(res.super_admin_id);
                } else {
                    console.error("Super admin not found");
                }
            },
            error: function (err) {
                console.error("Failed to load super admin", err);
            }
        });

    }, []);



    function setDropDown(parsedResult) {
        const select = document.getElementById("allprojects");

        // Clear old options except "All"
        select.length = 1;

        parsedResult.forEach(project => {
            const option = document.createElement("option");
            option.value = project.proid;
            option.textContent = project.pro_name;
            select.appendChild(option);
        });
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    const handleDateChange = (date) => {
        setSelectedDate(date);
        fetchActivity(date);
    }

    const fetchActivity = async (date) => {
        setLoading(true);

        const formattedDate = date.toISOString().split('T')[0];
        const projectId = document.getElementById("allprojects").value;

        try {
            const response = await fetch('activity_by_date.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user_id: localStorage.getItem('member_id'),
                    date: formattedDate,
                    project_id: projectId   // 👈 NEW
                })
            });

            const data = await response.json();
            console.log(data)
            setTasks(data);
            const summaryText = buildDailySummary(data);
            setDailySummary(summaryText);
        } catch (error) {
            console.error(error);
            setTasks([]);
        }

        setLoading(false);
    };


    const callFatchrecord = () => {
        fetchActivity(selectedDate); // whatever state holds your date
        loadMemberListForProject()
    };

    function loadMemberListForProject() {
        const active_pro_id = document.getElementById("allprojects").value;
        var obj = {
            pro_id: active_pro_id,
            comid: localStorage.getItem('mem_company_id')
        }
        console.log(obj);
        $.ajax({
            type: 'POST',
            url: 'getSelectedProjectMember.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;

                if (res !== 'fail' && res !== '') {
                    try {
                        var memarr = res;
                        // ensure it's an array
                        if (Array.isArray(memarr)) {
                            var len = memarr.length;
                            if (len < 1) {
                                showAlert('Cannot find any member for this project.');
                            } else {

                                populateMemberDropdown(memarr);
                            }
                        } else {
                            showAlert('Cannot find any member for this project.');
                            populateMemberDropdown([]);
                        }

                    } catch (e) {
                        console.error("Invalid JSON from backend:", e);
                        $('#memnum').text('0');
                        populateMemberDropdown([]);
                    }
                } else {
                    showAlert('Cannot find any member for this project.');
                    $('#memnum').text('0');
                    populateMemberDropdown([]);
                }
            },
            error: function (xhr, status, error) {
                console.error("AJAX Error:", status, error, xhr.responseText);
            }
        });
    }

    function populateMemberDropdown(members) {
        const select = document.getElementById("allmember");

        // Keep the first default option
        select.innerHTML = '<option value="all">Select Recipient</option>';

        members.forEach(mem => {
            const option = document.createElement("option");
            option.value = mem.member_id;
            option.textContent = mem.member_name;
            select.appendChild(option);
        });
    }




    const downloadPDF = () => {
        const doc = new jsPDF()

        doc.text('Daily Activity Report', 14, 15)
        doc.text(`Date of Report: ${selectedDate.toDateString()}`, 14, 25)
        doc.text(`Name: ${localStorage.getItem('membername')}`, 14, 35)

        autoTable(doc, {
            head: [['#', 'Task', 'Task Details', 'Start Time', 'End Time', 'Worked Time']],
            body: tasks.map((task, index) => ([
                index + 1,
                task.task_name,
                task.task_details,
                task.start_time,
                task.end_time,
                task.time_worked
            ])),
            startY: 45
        })

        doc.save('activity-report.pdf')
    }

    const timeToMinutes = (time) => {
        if (!time) return 0;
        const [h, m, s] = time.split(':').map(Number);
        return (h * 60) + m + Math.floor(s / 60);
    };
    const minutesToReadable = (mins) => {
        const h = Math.floor(mins / 60);
        const m = mins % 60;
        return `${h ? h + 'h ' : ''}${m}m`;
    };
    const getTaskStatus = (task) => {
        if (task.end_time && task.end_time !== '00:00:00') {
            return 'Completed';
        }
        return 'In Progress';
    };

    function buildDailySummary(tasks) {
        if (!tasks || tasks.length === 0) {
            return "No work recorded for this day.";
        }

        let totalSeconds = 0;
        let lines = [];

        tasks.forEach((task) => {
            // Supports HH:MM or HH:MM:SS
            const parts = task.time_worked.split(':').map(Number);

            let secs = 0;
            if (parts.length === 3) {
                secs = parts[0] * 3600 + parts[1] * 60 + parts[2];
            } else if (parts.length === 2) {
                secs = parts[0] * 3600 + parts[1] * 60;
            }

            totalSeconds += secs;

            lines.push(
                `Task: ${task.task_name} | Project: ${task.project_name} | Details: ${task.task_details} | ${task.start_time} → ${task.end_time} | ${task.time_worked}`
            );
        });

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        // zero-pad
        const pad = (n) => String(n).padStart(2, '0');

        lines.push('-----------------------------------');
        lines.push(`Total Time: ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`);

        return lines.join('\n');
    }


    function formatDateLocal(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }


    function saveDailyReport() {
        if (reportsent === 'no') {
            setReportsent('yes')
            const selectedMember = document.getElementById("allmember").value;

            // convert to null if "all"
            const recipient_id =
                selectedMember !== "all" ? selectedMember : 0;
            const payload = {
                user_id: localStorage.getItem('member_id'),
                username: localStorage.getItem('membername'),
                company_id: localStorage.getItem('mem_company_id'),
                project_id:
                    document.getElementById("allprojects").value === "all"
                        ? null
                        : document.getElementById("allprojects").value,
                report_date: formatDateLocal(selectedDate),
                summary: dailySummary,
                adminid: superAdminId,
                issues: document.getElementById("issuetext").value || null,
                tomorrow_plan: document.getElementById("tomorrowplan").value || null,
                recipient_id: recipient_id, // 🔹 single optional recipient
                member_img: localStorage.getItem('memberimg')
            };
            console.log(payload)
            $.ajax({
                type: "POST",
                url: "saveDailyReport.php",
                data: JSON.stringify(payload),
                contentType: "application/json",
                success: function (res) {
                    console.log(res);
                    if (res.status === "success") {

                        showAlert("Report sent successfully!");
                    } else {
                        showAlert("Failed to send report.");
                    }
                }
            });
        } else {
            showAlert("Report already sent successfully!");
        }
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };



    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Daily Report</h2>
                    <Link className='pull_right add_new_pro' to="/report_inbox">Report Inbox</Link>
                    <Link className='pull_right add_new_pro' to="/report_history">Report History</Link>
                </div>
                <section className='mainsection'>
                    <div className='vl_dsh_container'>
                        <div className='vl_dsh_two_third'>
                            <div className='fullwidth date_holder pull_left'>
                                <div className='vl_dsh_one_third'>
                                    <div className='dateselector'>
                                        <label className='datelabel'>Select Date:</label><br />
                                        <DatePicker
                                            selected={selectedDate}
                                            onChange={handleDateChange}
                                            maxDate={new Date()}
                                            dateFormat="yyyy-MM-dd"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            yearDropdownItemNumber={50}
                                            scrollableYearDropdown
                                        />
                                    </div>
                                </div>
                                <div className='vl_dsh_one_third'>
                                    <label className='datelabel'>Select Project:</label><br />
                                    <select id="allprojects" onChange={callFatchrecord}>
                                        <option value="all">All Projects</option>
                                    </select>
                                </div>
                                <div className='vl_dsh_one_third'>
                                    <label className='datelabel'>Send To:</label><br />

                                    <select id="allmember">
                                        <option value="all">Select Recipient</option>
                                    </select>
                                </div>
                            </div>
                            <div className='fullwidth tasklistarea mt-20 pull_left'>
                                {/* 🔄 Loading */}
                                {loading && <p>Loading activity...</p>}
                                {!loading && tasks.length === 0 && (
                                    <h3 class="notice_text visbleitem">No activity found for this day.</h3>
                                )}
                                {tasks.length > 0 && (
                                    <>
                                        <table className="activity-table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Task</th>
                                                    <th>Task Details</th>
                                                    <th>Start</th>
                                                    <th>End</th>
                                                    <th>Worked</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tasks.map((task, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{task.task_name}</td>
                                                        <td>{task.task_details}</td>
                                                        <td>{task.start_time}</td>
                                                        <td>{task.end_time}</td>
                                                        <td>{task.time_worked}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {/* 📄 PDF Button */}
                                        <button className='downlaodBTN'
                                            style={{ marginTop: '15px' }}
                                            onClick={downloadPDF}                                        >
                                            Download PDF <i className='ri-download-2-fill'></i>
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className='vl_dsh_one_third'>
                            <div className='blocksection'>
                                <h2><i className='ri-article-line'></i>  Today's Summery</h2>
                                <div className='blockcontent'>
                                    <pre className="summary-text">
                                        {dailySummary}
                                    </pre>
                                </div>

                            </div>
                            <div className='blocksection'>
                                <h2><i className='ri-lock-2-fill'></i>  Blockers/Issues</h2>
                                <p>Please document any blockers, issues, or challenges encountered during your work.</p>
                                <div className='blockcontent'>
                                    <textarea id="issuetext"></textarea>
                                </div>
                            </div>
                            <div className='blocksection'>
                                <h2><i className='ri-rocket-2-line'></i>  Tomorrow's Plan</h2>
                                <div className='blockcontent'>
                                    <textarea id="tomorrowplan"></textarea>
                                </div>
                            </div>
                            <p>This report  will go to admin/project manager automatically. If you want to send any other member of team you can select him from the above dropdown.</p>
                            <button className='downlaodBTN'
                                style={{ marginTop: '15px', float: "right" }}
                                onClick={saveDailyReport}                                        >
                                Send Report <i class="ri-mail-send-line"></i>
                            </button>
                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>

                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
